import { BrowserRouter, Routes, Route, Navigate, Outlet, useParams } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Layout from "@/components/Layout";
import { LocaleProvider, LOCALES } from "@/lib/i18n";
import Home from "@/pages/Home";
import { About, Sessions, Peru, Club, Contact, Faq, NotFound } from "@/pages/Info";
import Book from "@/pages/Book";
import { Oracle, Cart } from "@/pages/Oracle";
import { LoveTarot, LoveOracle } from "@/pages/Love";
import Calendar from "@/pages/Calendar";
import { Library, Article } from "@/pages/Library";
import { Donate } from "@/components/extras";
import { SoulPostsPage } from "@/components/homeExtras";
import Policy from "@/pages/Policy";
import { Account, PaymentResult, SessionRoom } from "@/pages/Account";
import Admin from "@/pages/Admin";

function LocaleShell() {
  const { locale } = useParams();
  if (!LOCALES.includes(locale)) return <Navigate to="/en" replace />;
  return <LocaleProvider value={locale}><Outlet /></LocaleProvider>;
}

const rootLocale = () => localStorage.getItem("aa_locale") || "en";
const AuthWrap = ({ children }) => <div className="wrap py-16 flex items-center justify-center">{children}</div>;

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Toaster position="top-center" />
        <Routes>
          <Route path="/" element={<Navigate to={`/${rootLocale()}`} replace />} />
          <Route path="/sign-in/*" element={<AuthWrap><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl={`/${rootLocale()}/account`} /></AuthWrap>} />
          <Route path="/sign-up/*" element={<AuthWrap><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl={`/${rootLocale()}/account`} /></AuthWrap>} />
          <Route path="/admin/*" element={<LocaleProvider value="en"><Admin /></LocaleProvider>} />
          <Route path="/:locale" element={<LocaleShell />}>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="sessions" element={<Sessions />} />
              <Route path="book" element={<Book />} />
              <Route path="oracle" element={<Oracle />} />
              <Route path="shop" element={<Oracle />} />
              <Route path="cart" element={<Cart />} />
              <Route path="checkout" element={<Cart />} />
              <Route path="love-tarot" element={<LoveTarot />} />
              <Route path="love-oracle" element={<LoveOracle />} />
              <Route path="love-oracle/result" element={<LoveOracle />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="peru" element={<Peru />} />
              <Route path="library" element={<Library />} />
              <Route path="library/:slug" element={<Article />} />
              <Route path="club" element={<Club />} />
              <Route path="contact" element={<Contact />} />
              <Route path="faq" element={<Faq />} />
              <Route path="donate" element={<Donate />} />
              <Route path="soul-posts" element={<SoulPostsPage />} />
              {["privacy", "terms", "cookies", "booking-policy", "shipping-returns", "accessibility"].map((p) => <Route key={p} path={p} element={<Policy kind={p} />} />)}
              <Route path="sign-in" element={<Navigate to="/sign-in" replace />} />
              <Route path="join" element={<Navigate to="/sign-up" replace />} />
              <Route path="verify-email" element={<Navigate to="/sign-up" replace />} />
              <Route path="reset-password" element={<Navigate to="/sign-in" replace />} />
              <Route path="account" element={<Account />} />
              <Route path="account/:tab" element={<Account />} />
              <Route path="payment/:result" element={<PaymentResult />} />
              <Route path="session/:id" element={<SessionRoom />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
